<template lang="pug">
  Layout
    v-card.mt-5.full-width(width="100")
      v-card-title
        FormWrapper.fill-height(
          type="reward",
          no-spacing,
        )
          template( v-slot:default="props")
            RewardModal(
              :model="props.model",
              :validate="props.validate",
              :valid="props.valid",
              :reset="props.reset",
              @updated="fetchUser()",
            )
              template(v-slot="{ open }")
                Header(
                  icon="coins",
                  color="primary",
                  @click="open",
                )
        RedeemableModal(
          @updated="fetchUser()",
        )
          template(v-slot="{ open }")
            Header.ml-2(
              icon="gifts",
              color="primary",
              @click="open",
            )
        v-spacer
        v-chip.bold(
          outlined,
          color="primary",
        ) {{ $t('global.point') }}: {{ user.points }}
      TableWrapper(
        loading-text="Loading... Please wait",
        type="point",
        :items="items",
        :misc="misc",
      )
        template(v-slot:default="{ item, headers, misc }")
          RowWrapper(
            hide-delete,
            type="point",
            :headers="headers",
            :item="item",
            :misc="misc",
          )
</template>

<script>
import { mapGetters } from 'vuex';
import { concat } from 'ramda';

import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Header from '@/components/forms/Header.vue';
import Layout from '@/layouts/User.vue';
import RedeemableModal from '@/components/forms/RedeemableModal.vue';
import RewardModal from '@/components/forms/RewardModal.vue';
import RowWrapper from '@/components/wrapper/RowWrapper.vue';
import TableWrapper from '@/components/wrapper/TableWrapper.vue';

export default {
  name: 'points',

  components: {
    Layout,
    Header,
    FormWrapper,
    RedeemableModal,
    RewardModal,
    RowWrapper,
    TableWrapper,
  },

  data: () => ({
    misc: {
      sortBy: 'createdAt',
      sortDesc: true,
    },
  }),

  computed: {
    ...mapGetters({ user: 'user/user' }),

    items() {
      const redeemedItems = this.user.redeemedItems || [];
      const rewards = this.user.rewards || [];

      return redeemedItems.concat(rewards);
    },
  },

  methods: {
    fetchUser() {
      this.$store.dispatch('user/find', this.$route.params.id);
    },
  },
};
</script>
